module.exports = __webpack_public_path__ + "static/media/start_grau.8e4d3de7.jpg";